export var JobTitle;
(function (JobTitle) {
    JobTitle["ChiefExecutiveOfficer"] = "Chief Executive Officer";
    JobTitle["ChiefFinancialOfficer"] = "Chief Financial Officer";
    JobTitle["ChiefOperatingOfficer"] = "Chief Operating Officer";
    JobTitle["President"] = "President";
    JobTitle["VicePresident"] = "Vice President";
    JobTitle["ExecutivePresident"] = "Executive President";
    JobTitle["ManagingMember"] = "Managing Member";
    JobTitle["Partner"] = "Partner";
    JobTitle["Treasurer"] = "Treasurer";
    JobTitle["Director"] = "Director";
    JobTitle["Other"] = "Other";
})(JobTitle || (JobTitle = {}));
//# sourceMappingURL=JobTitle.js.map